module.exports = __webpack_public_path__ + "static/media/halloween.f29f87ac.svg";